import { defineNuxtPlugin } from '#imports'
import { createFrontAxiosClientAnonymous } from '@b2ag/axios-client'
import { provideFeatureFlipping } from '@b2ag/feature-flipping'
import { getAppContext, getConfig } from '@b2ag/micro-front-tools'
import { currentAppBrand } from '@b2ag/app-brands'

export default defineNuxtPlugin({
  name: 'feature flipping',
  enforce: 'pre',
  dependsOn: ['store'],
  setup() {
    const { appFrontType } = getAppContext()
    const featureFlippingApiClient = createFrontAxiosClientAnonymous(`${getConfig('FEATURE_FLIPPING_API_HOST')}`, {
      callerId: undefined,
      localeSource: undefined,
    })

    provideFeatureFlipping(featureFlippingApiClient, appFrontType, currentAppBrand)
  },
})
